<template>
    <!--弹窗-->
    <el-dialog v-if="visible" width="900px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <div class="chart-datepicker">
            <div class="range-option" @click="getList_od(charts_id, 30)" :style="index == 30 ? 'font-weight: bold;color: #508cfd;' : ''">30 天</div>
            <div class="range-option" @click="getList_od(charts_id, 90)" :style="index == 90 ? 'font-weight: bold;color: #508cfd;' : ''">90 天</div>
            <div class="range-option" @click="getList_od(charts_id, 365)" :style="index == 365 ? 'font-weight: bold;color: #508cfd;' : ''">1 年</div>
            <div class="range-option" @click="getList_od(charts_id, null)" :style="index == null ? 'font-weight: bold;color: #508cfd;' : ''">全部</div>
        </div>
        <div v-loading="loading" :id="'highcharts-' + charts_id" style="min-height: 400px;"></div>
        <el-divider></el-divider>
        <div class="phrase">
            <div class="phrase-stats">
                <div>
                    最高排名:  
                    <div class="stat-top-info" v-if="min_num != null">
                        <span>{{ min_num }}</span>
                        <span>( {{ min_date }} )</span>
                    </div>
                    <span v-else> - </span>
                </div>
                <div>
                    最低排名: 
                    <div class="stat-top-info" v-if="max_num != null">
                        <span>{{ max_num }}</span>
                        <span>( {{ max_date }} )</span>
                    </div>
                    <span v-else> - </span>
                </div>
            </div>
            <div v-if="arrCharts.length > 1" class="phrase-div" style="padding: 18.6px;">
                <el-button @click="switchData()" :disabled="loading" v-if="isvisible" type="primary" size="small">隐藏竞争ASIN</el-button>
                <el-button @click="switchData()" :disabled="loading" v-else size="small">展示竞争ASIN</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
import * as Highcharts from "highcharts";
import * as loadExporting from "highcharts/modules/exporting";
import * as exportExcel from "highcharts/modules/export-data.src";
loadExporting(Highcharts);
exportExcel(Highcharts);
export default {
    data() {
        return {
            loading: false,
            index: 0,
            max_num: null,
            max_date: null,
            min_num: null,
            charts: null,
            asin_id: null,
            arrCharts: [],
            remark_obj: {},
            page_obj: {},
            dateCharts: null,
            isvisible: true,
            min_date: null
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        asin: {
            type: String,
            default: ""
        },
        charts_id: {
            type: String,
            default: "0"
        },
        charts_keyword: {
            type: String,
            default: ""
        }
    },
    methods: {
        //最小值
        math_Max_Min(date, rank) {
            let max_num = rank[0];
            let max_date = date[0];
            let min_num = rank[0];
            let min_date = date[0];
            for (let i = 1; i < rank.length; i++) {
                if (rank[i] != null) {
                    if (rank[i] > max_num || max_num == null) {
                        max_num = rank[i];
                        max_date = date[i];
                    }
                    if (min_num == null || min_num > rank[i]) {
                        min_num = rank[i];
                        min_date = date[i];
                    }
                }
            }
            this.max_num = max_num;
            this.max_date = max_date;
            this.min_num = min_num;
            this.min_date = min_date;
        },
        qiestr(str) {
            let srting = "";
            if (str.length > 39) {
                srting = str.slice(0, 37);
                srting += "...";
            } else {
                srting = str;
            }
            return srting;
        },
        getList_od(id, index) {
            if (this.index == index) return;
            this.getList(id, index);
        },
        getList_onRemark(id) {
            this.getList(id, this.index);
        },
        getList(id, index) {
            this.asin_id = id;
            this.index = index;
            this.loading = true;
            api.trend_batch({ keyword_ids: [id], days: index, with_title: 1 })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.math_Max_Min(res.data[id].date, res.data[id].rank);
                        let arr = [];
                        for (let key in res.data[id]) {
                            let obj = {};
                            if (key == "rank") {
                                obj.name = "你的产品";
                                obj.asin = this.formData.asin;
                                obj.title = this.qiestr(this.charts_keyword);
                                obj.data = res.data[id][key];
                                obj.selected = true;
                                obj.visible = true;
                                arr.push(obj);
                            } else if (
                                key != "date" &&
                                key != "title" &&
                                key != "page" &&
                                key != "remark"
                            ) {
                                obj.name = key;
                                obj.asin = key;
                                obj.title = this.qiestr(
                                    res.data[id].title[key]
                                );
                                obj.data = res.data[id][key];
                                obj.selected = true;
                                obj.visible = true;
                                arr.push(obj);
                            }
                            if (key == "remark") {
                                this.remark_obj = res.data[id][key];
                            }
                        }
                        this.arrCharts = arr;
                        this.dateCharts = res.data[id].date;
                        let page_obj = {};
                        for (let i = 0; i < this.dateCharts.length; i++) {
                            page_obj[this.dateCharts[i]] = res.data[id].page[i];
                        }
                        this.page_obj = page_obj;
                        this.getCharts(res.data[id].date, arr);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getCharts(date, data) {
            let that = this;
            Highcharts.chart("highcharts-" + this.charts_id, {
                chart: {
                    type: "line"
                },
                title: {
                    text: null
                },
                yAxis: {
                    allowDecimals: false,
                    reversed: true,
                    min: 1,
                    title: {
                        text: null
                    }
                },
                xAxis: {
                    categories: date,
                    title: {
                        text: "DateTime"
                    },
                    tickInterval: Math.ceil(date.length / 6),
                    tickWidth: 1
                },
                tooltip: {
                    crosshairs: [
                        {
                            width: 1,
                            color: "#ddd"
                        }
                    ],
                    shared: true,
                    // headerFormat: "<small>{point.key}</small><br/><table>",
                    // pointFormat:
                    //     "<br/><div style='color: {series.color}'>{series.name} <b>{point.y}</b><br/><br/>",
                    formatter: function() {
                        var s =
                            "<div style='font-weight: 900;'>" +
                            this.x +
                            "</div>";
                        for (let i = 0; i < this.points.length; i++) {
                            s +=
                                "<br/><br/>" +
                                "<div style='color: " +
                                this.points[i].series.color +
                                "'>" +
                                this.points[i].series.userOptions.title +
                                "</div><br/><div>" +
                                this.points[i].series.userOptions.asin +
                                " ：<b>" +
                                this.points[i].y +
                                "</b></div><br/>" +
                                `${
                                    this.points[i].series.userOptions.asin ==
                                    that.asin
                                        ? `<div>页数 ：<b>${
                                              that.page_obj[this.x]
                                          }</div>`
                                        : ""
                                }` +
                                "<br/>";
                        }
                        return s;
                    }
                    // footerFormat: "</table>"
                    // footerFormat:
                    //     "</table>"
                    // pointFormat: `<br/><div style="color: rgb(134, 178, 234) !important;">${
                    //     this.charts_keyword
                    // }</div>
                    // <br/>{series.name}: <b>{point.y}</b><br/><br/><div style="color: rgb(0, 123, 255) !important;">单击点添加注释</div>`
                },
                plotOptions: {
                    series: {
                        cursor: "pointer",
                        label: {
                            connectorAllowed: false
                        },
                        events: {
                            show: function(event) {
                                if (event.target.name == "你的产品") return;
                                that.isvisible = true;
                            },
                            hide: function(event) {
                                if (event.target.name == "你的产品") return;
                                let seriesArr = event.target.chart.series;
                                for (let i = 0; i < seriesArr.length; i++) {
                                    if (seriesArr[i].name != "你的产品") {
                                        if (seriesArr[i].visible) {
                                            that.isvisible = true;
                                            return;
                                        }
                                    }
                                }
                                that.isvisible = false;
                            }
                        }
                    }
                },
                legend: {
                    enabled: data.length == 1 ? false : true
                },
                credits: { enabled: false },
                series: data,
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom"
                                }
                            }
                        }
                    ]
                },
                exporting: {
                    filename: `${this.title} (数据统计图)`,
                    menuItemDefinitions: {
                        printChart: {
                            text: "打印图表"
                        },
                        downloadJPEG: {
                            text: "下载JPEG 图片"
                        },
                        downloadPDF: {
                            text: "下载PDF 文档"
                        },
                        downloadPNG: {
                            text: "下载PNG 图片"
                        },
                        downloadSVG: {
                            text: "下载SVG 矢量图"
                        },
                        exportButtonTitle: {
                            text: "导出图片"
                        },
                        downloadCSV: {
                            text: "下载CSV 数据表"
                        },
                        downloadXLS: {
                            text: "下载XLS 数据表"
                        }
                    },
                    buttons: {
                        contextButton: {
                            menuItems: [
                                "printChart",
                                "separator",
                                "downloadJPEG",
                                "downloadPDF",
                                "downloadPNG",
                                "downloadSVG",
                                "separator",
                                "downloadCSV",
                                "downloadXLS"
                            ]
                        }
                    }
                }
            });
        },
        switchData() {
            if (this.isvisible) {
                for (let i = 0; i < this.arrCharts.length; i++) {
                    if (this.arrCharts[i].name != "你的产品") {
                        this.arrCharts[i].visible = false;
                        this.arrCharts[i].selected = false;
                    }
                }
                this.isvisible = false;
            } else {
                for (let i = 0; i < this.arrCharts.length; i++) {
                    if (this.arrCharts[i].name != "你的产品") {
                        this.arrCharts[i].visible = true;
                        this.arrCharts[i].selected = true;
                    }
                }
                this.isvisible = true;
            }
            this.getCharts(this.dateCharts, this.arrCharts);
        },
        // 关闭弹窗
        handleClose() {
            this.index = 0;
            this.max_num = null;
            this.max_date = null;
            this.min_num = null;
            this.min_date = null;
            this.loading = false;
            this.isvisible = true;
            this.$emit("close-callback", true);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.chart-datepicker {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    margin-bottom: 20px;
}
.range-option {
    font-size: 13px;
    color: #3a3a3a;
    padding: 0 10px;
    text-decoration: underline;
    cursor: pointer;
}
.range-option:hover {
    color: #666;
    text-decoration: none;
}
.phrase {
    display: flex;
    justify-items: center;
    justify-content: space-between;
}
.phrase-stats {
    margin-left: 10px;
    margin-bottom: 10px;
    div {
        line-height: 30px;
        font-weight: 700;
        font-size: 16px;
    }
    span {
        margin-right: 5px;
    }
}
.stat-top-info {
    display: inline-block;
}
/deep/ .el-dialog__body {
    padding: 10px 20px 20px 20px !important;
}
</style>
